// extracted by mini-css-extract-plugin
export var backButton = "_14-1";
export var content = "_14-d";
export var continueButton = "_14-7";
export var continueHint = "_14-8";
export var continueRow = "_14-6";
export var leftInner = "_14-0";
export var shell = "_14-e";
export var sidebarContent = "_14-5";
export var skipButton = "_14-c";
export var spacer = "_14-2";
export var spin = "_14-a";
export var spinner = "_14-9";
export var spinnerOverlay = "_14-b";
export var subtitle = "_14-4";
export var title = "_14-3";